import { AuthGuard } from "guards";
import { AuthLayout, Layout, NavLayout, PublicLayout } from "layouts";
import { aprPageRoute } from "pages/ed-reports/AprPage/AprPage";
import { exportPageRoute } from "pages/reports/ExportPage/ExportPage";
import { homePageRoute } from "pages/HomePage/HomePage";
import { testPageRoute } from "pages/TestPage/TestPage";
import { thankYouPageRoute } from "pages/ThankYouPage/ThankYouPage";
import { the404PageRoute } from "pages/The404Page/The404Page";
import { UserManualContent } from "pages/UserManual/UserManualContent";
import { userManualPageRoute } from "pages/UserManual/UserManualPage";
import { forgotCredentialPageRoute } from "pages/auth/ForgotCredentialPage/ForgotCredentialPage";
import { loginPageRoute } from "pages/auth/LoginPage/LoginPage";
import { resetPasswordPageRoute } from "pages/auth/ResetPasswordPage/ResetPasswordPage";
import { userRegisterPageRoute } from "pages/auth/UserRegisterPage/UserRegisterPage";
import { applicationListPageRoute } from "pages/cobro/applications/ApplicationListPage/ApplicationListPage";
import { applicationPageRoute } from "pages/cobro/applications/ApplicationPage/ApplicationPage";
import { developerBulkUpdatePageRoute } from "pages/cobro/developers/DeveloperBulkUpdatePage/DeveloperBulkUpdatePage";
import { developerListPageRoute } from "pages/cobro/developers/DeveloperListPage/DeveloperListPage";
import { developerPageRoute } from "pages/cobro/developers/DeveloperPage/DeveloperPage";
import { cobroSurveyExportPageRoute } from "pages/cobro/survey-export/CobroSurveyExportPage";
import { surveyExportPageRoute } from "pages/surveys/survey-export/SurveyExportPage";
import { surveyResponseListPageRoute } from "pages/cobro/survey-responses/SurveyResponseListPage/SurveyResponseListPage";
import { surveyListPageRoute } from "pages/cobro/surveys/SurveyListPage/SurveyListPage";
import { surveyPageRoute } from "pages/cobro/surveys/SurveyPage/SurveyPage";
import { dataCenterFileCreatePageRoute } from "pages/data-center/dataCenterFiles/DataCenterFileCreatePage/DataCenterFileCreatePage";
import { dataCenterFileListPageRoute } from "pages/data-center/dataCenterFiles/DataCenterFileListPage/DataCenterFileListPage";
import { dataCenterFileViewPageRoute } from "pages/data-center/dataCenterFiles/DataCenterFileViewPage/DataCenterFileViewPage";
import { contributorEmploymentPageRoute } from "pages/match-main/contributor-employments/ContributorEmploymentPage/ContributorEmploymentPage";
import { contributorMatchBulkUpdatePageRoute } from "pages/match-main/contributor-matches/ContributorMatchBulkUpdatePage/ContributorMatchBulkUpdatePage";
import { contributorMatchListPageRoute } from "pages/match-main/contributor-matches/ContributorMatchListPage/ContributorMatchListPage";
import { contributorMatchPageRoute } from "pages/match-main/contributor-matches/ContributorMatchPage/ContributorMatchPage";
import { contributorBulkCreateMatchesPageRoute } from "pages/match-main/contributors/ContributorBulkCreateMatchesPage/ContributorBulkCreateMatchesPage";
import { contributorBulkMergePageRoute } from "pages/match-main/contributors/ContributorBulkMergePage/ContributorBulkMergePage";
import { contributorCreatePageRoute } from "pages/match-main/contributors/ContributorCreatePage/ContributorCreatePage";
import { contributorListPageRoute } from "pages/match-main/contributors/ContributorListPage/ContributorListPage";
import { contributorPageRoute } from "pages/match-main/contributors/ContributorPage/ContributorPage";
import { nonPersonnelListPageRoute } from "pages/match-main/nonPersonnels/NonPersonnelListPage/NonPersonnelListPage";
import { nonPersonnelPageRoute } from "pages/match-main/nonPersonnels/NonPersonnelPage/NonPersonnelPage";
import { matchReportPageRoute } from "pages/match-main/reports/MatchReportPage/MatchReportPage";
import { contributorMatchServiceListPageRoute } from "pages/match-utility/contributor-match-services/ContributorMatchServiceListPage/ContributorMatchServiceListPage";
import { contributorMatchServicePageRoute } from "pages/match-utility/contributor-match-services/ContributorMatchServicePage/ContributorMatchServicePage";
import { partnerIndirectCostPageRoute } from "pages/match-utility/partner-indirect-costs/PartnerIndirectCostPage/PartnerIndirectCostPage";
import { partnerCreatePageRoute } from "pages/match-utility/partners/PartnerCreatePage/PartnerCreatePage";
import { partnerListPageRoute } from "pages/match-utility/partners/PartnerListPage/PartnerListPage";
import { partnerPageRoute } from "pages/match-utility/partners/PartnerPage/PartnerPage";
import { regionListPageRoute } from "pages/system/utility/regions/RegionListPage/RegionListPage";
import { regionPageRoute } from "pages/system/utility/regions/RegionPage/RegionPage";
import { subPartnerPageRoute } from "pages/match-utility/sub-partners/SubPartnerPage/SubPartnerPage";
import { suppliesDetailListPageRoute } from "pages/match-utility/supplies-details/SuppliesDetailListPage/SuppliesDetailListPage";
import { suppliesDetailPageRoute } from "pages/match-utility/supplies-details/SuppliesDetailPage/SuppliesDetailPage";
import { homelessDefinitionPageRoute } from "pages/public-forms/applications/HomelessDefinition";
import { publicApplicationPageRoute } from "pages/public-forms/applications/PublicApplicationPage";
import { publicSurveyPageRoute } from "pages/public-forms/surveys/PublicSurveyPage";
import { studentReportPageRoute } from "pages/reports/StudentReportPage/StudentReportPage";
import { studentAbsencePageRoute } from "pages/students/student-absences/StudentAbsencePage/StudentAbsencePage";
import { studentDiplomaPageRoute } from "pages/students/student-diplomas/StudentDiplomaPage/StudentDiplomaPage";
import { studentEnrollmentBulkUpdatePageRoute } from "pages/students/student-enrollments/StudentEnrollmentBulkUpdatePage/StudentEnrollmentBulkUpdatePage";
import { studentEnrollmentListPageRoute } from "pages/students/student-enrollments/StudentEnrollmentListPage/StudentEnrollmentListPage";
import { studentEnrollmentPageRoute } from "pages/students/student-enrollments/StudentEnrollmentPage/StudentEnrollmentPage";
import { studentFafsaPageRoute } from "pages/students/student-fafsas/StudentFafsaPage/StudentFafsaPage";
import { studentGpaPageRoute } from "pages/students/student-gpas/StudentGpaPage/StudentGpaPage";
import { studentGradeBulkCreatePageRoute } from "pages/students/student-grades/StudentGradeBulkCreatePage/StudentGradeBulkCreatePage";
import { studentGradePageRoute } from "pages/students/student-grades/StudentGradePage/StudentGradePage";
import { studentGroupBulkUpdatePageRoute } from "pages/students/student-groups/StudentGroupBulkUpdatePage/StudentGroupBulkUpdatePage";
import { studentGroupListPageRoute } from "pages/students/student-groups/StudentGroupListPage/StudentGroupListPage";
import { studentGroupPageRoute } from "pages/students/student-groups/StudentGroupPage/StudentGroupPage";
import { studentParentPageRoute } from "pages/students/student-parents/StudentParentPage/StudentParentPage";
import { parentTextingOptInPageRoute } from "pages/students/student-parents/StudentParentPage/StudentParentTextingOptInPage";
import { studentScholarshipPageRoute } from "pages/students/student-scholarships/StudentScholarshipPage/StudentScholarshipPage";
import { studentServiceTemplateListPageRoute } from "pages/students/student-service-templates/StudentServiceTemplateListPage/StudentServiceTemplateListPage";
import { studentLinkPageRoute } from "pages/students/student-service-templates/StudentServiceTemplatePage/StudentLinkPage/StudentLinkPage";
import { studentServiceTemplatePageRoute } from "pages/students/student-service-templates/StudentServiceTemplatePage/StudentServiceTemplatePage";
import { studentServiceTemplateSignUpPageRoute } from "pages/students/student-service-templates/StudentServiceTemplateSignUpPage/StudentServiceTemplateSignUpPage";
import { studentServiceBulkUpdatePageRoute } from "pages/students/student-services/StudentServiceBulkUpdatePage/StudentServiceBulkUpdatePage";
import { studentServiceListPageRoute } from "pages/students/student-services/StudentServiceListPage/StudentServiceListPage";
import { studentServicePageRoute } from "pages/students/student-services/StudentServicePage/StudentServicePage";
import { studentTestPageRoute } from "pages/students/student-tests/StudentTestPage/StudentTestPage";
import { studentBulkAssignGroupPageRoute } from "pages/students/students/StudentBulkAssignGroupPage/StudentBulkAssignGroupPage";
import { studentBulkCreateServicesPageRoute } from "pages/students/students/StudentBulkCreateServicesPage/StudentBulkCreateServicesPage";
import { studentBulkUpdatePageRoute } from "pages/students/students/StudentBulkUpdatePage/StudentBulkUpdatePage";
import { studentCreatePageRoute } from "pages/students/students/StudentCreatePage/StudentCreatePage";
import { studentListPageRoute } from "pages/students/students/StudentListPage/StudentListPage";
import { studentPageRoute } from "pages/students/students/StudentPage/StudentPage";
import { StudentQrPage } from "pages/students/students/studentqrpage/StudentQrPage";
import { studentQrPageRoute } from "pages/students/students/studentqrpage/studentQrPageRoute";
import { customDataModelFieldListPageRoute } from "pages/system/custom-data-model-fields/CustomDataModelFieldListPage/CustomDataModelFieldListPage";
import { customDataModelFieldPageRoute } from "pages/system/custom-data-model-fields/CustomDataModelFieldPage/CustomDataModelFieldPage";
import { UtilityLayout, utilityLayoutRoutePath } from "pages/system/utility/_layouts/UtilityLayout";
import { ClassListPageRoute } from "pages/system/utility/Classes/ClassListPage/ClassListPage";
import { ClassPageRoute } from "pages/system/utility/Classes/ClassPage/ClassPage";
import { cohortListPageRoute } from "pages/system/utility/cohorts/CohortListPage/CohortListPage";
import { cohortPageRoute } from "pages/system/utility/cohorts/CohortPage/CohortPage";
import { collegeListPageRoute } from "pages/system/utility/colleges/CollegeListPage/CollegeListPage";
import { collegePageRoute } from "pages/system/utility/colleges/CollegePage/CollegePage";
import { diplomaTypeListPageRoute } from "pages/system/utility/diplomaTypes/DiplomaTypeListPage/DiplomaTypeListPage";
import { diplomaTypePageRoute } from "pages/system/utility/diplomaTypes/DiplomaTypePage/DiplomaTypePage";
import { districtListPageRoute } from "pages/system/utility/districts/DistrictListPage/DistrictListPage";
import { districtPageRoute } from "pages/system/utility/districts/DistrictPage/DistrictPage";
import { disciplineListPageRoute } from "pages/system/utility/disciplines/DisciplineListPage/DisciplineListPage";
import { disciplinePageRoute } from "pages/system/utility/disciplines/DisciplinePage/DisciplinePage";
import { endReasonListPageRoute } from "pages/system/utility/endReasons/EndReasonListPage/EndReasonListPage";
import { endReasonPageRoute } from "pages/system/utility/endReasons/EndReasonPage/EndReasonPage";
import { iepListPageRoute } from "pages/system/utility/iep/IEPListPage/IEPListPage";
import { iepPageRoute } from "pages/system/utility/iep/IEPPage/IEPPage";
import { lepListPageRoute } from "pages/system/utility/lep/LepListPage/LEPListPage";
import { lepPageRoute } from "pages/system/utility/lep/LepPage/LEPPage";
import { scholarshipStatusListPageRoute } from "pages/system/utility/scholarshipStatus/ScholarshipStatusListPage/ScholarshipStatusListPage";
import { scholarshipStatusPageRoute } from "pages/system/utility/scholarshipStatus/ScholarshipStatusPage/ScholarshipStatusPage";
import { scholarshipPaymentMethodListPageRoute } from "pages/system/utility/scholarshipPaymentMethod/ScholarshipPaymentMethodListPage/ScholarshipPaymentMethodListPage";
import { scholarshipPaymentMethodPageRoute } from "pages/system/utility/scholarshipPaymentMethod/ScholarshipPaymentMethodPage/ScholarshipPaymentMethodPage";
import { scholarshipTypeListPageRoute } from "pages/system/utility/scholarshipTypes/ScholarshipTypeListPage/ScholarshipTypeListPage";
import { scholarshipTypePageRoute } from "pages/system/utility/scholarshipTypes/ScholarshipTypePage/ScholarshipTypePage";
import { schoolListPageRoute } from "pages/system/utility/schools/SchoolListPage/SchoolListPage";
import { schoolPageRoute } from "pages/system/utility/schools/SchoolPage/SchoolPage";
import { studentServiceTypeListPageRoute } from "pages/system/utility/studentServiceTypes/StudentServiceTypeListPage/StudentServiceTypeListPage";
import { studentServiceTypePageRoute } from "pages/system/utility/studentServiceTypes/StudentServiceTypePage/StudentServiceTypePage";
import { staffPositionListPageRoute } from "pages/system/utility/staffPosition/StaffPositionListPage/StaffPositionListPage";
import { staffPositionPageRoute } from "pages/system/utility/staffPosition/StaffPositionPage/StaffPositionPage";
import { staffServiceTypeListPageRoute } from "pages/system/utility/staffServiceTypes/StaffServiceTypeListPage/StaffServiceTypeListPage";
import { staffServiceTypePageRoute } from "pages/system/utility/staffServiceTypes/StaffServiceTypePage/StaffServiceTypePage";
import { userListPageRoute } from "pages/users/UserListPage/UserListPage";
import { userPageRoute } from "pages/users/UserPage/UserPage";
import { Navigate, RouteObject, useRoutes } from "react-router-dom";
import { pagesLoader } from "./pagesLoader";
import { dashboardReportPageRoute } from "pages/reports/DashboardReportPage/DashboardReportPage";
import { studentApplicationListPageRoute } from "pages/students/student-applications/StudentApplicationListPage/StudentApplicationListPage";
import { postHSPlanStatusPageRoute } from "pages/system/utility/postHSPlanStatus/PostHSPlanStatus/PostHSPlanStatus";
import { postHSPlanStatusListPageRoute } from "pages/system/utility/postHSPlanStatus/PostHSPlanStatusPage/PostHSPlanStatusListPage";
import { providerListPageRoute } from "pages/providers/providers/ProviderListPage/ProviderListPage";
import { providerCreatePageRoute } from "pages/providers/providers/ProviderCreatePage/ProviderCreatePage";
import { providerPageRoute } from "pages/providers/providers/ProviderPage/ProviderPage";
import { providerEmploymentPageRoute } from "pages/providers/provider-employments/ProviderEmploymentPage/ProviderEmploymentPage";
import { providerPositionListPageRoute } from "pages/system/utility/providerPositions/ProviderPositionListPage/ProviderPositionListPage";
import { providerPositionPageRoute } from "pages/system/utility/providerPositions/ProviderPositionPage/ProviderPositionPage";
import { gradeListPageRoute } from "pages/system/utility/grades/GradeListPage/GradeListPage";
import { gradePageRoute } from "pages/system/utility/grades/GradePage/GradePage";
import { studentPostHighSchoolPageRoute } from "pages/students/student-post-high-schools/StudentPostHighSchoolPage/StudentPostHighSchoolPage";
import { studentApplicationPageRoute } from "pages/students/student-applications/StudentApplicationPage/StudentApplicationPage";
import { studentBulkEmailPageRoute } from "pages/students/students/StudentBulkEmailPage/StudentBulkEmailPage";
import { studentEmailPageRoute } from "pages/students/students/StudentEmailPage/StudentEmailPage";
import {
  SurveyResponseStudentPage,
  surveyResponseStudentPageRoute,
} from "pages/cobro/survey-responses/SurveyResponseStudent/SurveyResponseStudentPage";
import { studentServiceIndexListPageRoute } from "pages/students/student-service-indexes/StudentServiceIndexListPage/StudentServiceIndexListPage";
import { studentServiceIndexPageRoute } from "pages/students/student-service-indexes/StudentServiceIndexPage/StudentServiceIndexPage";
import { nscCollegePageRoute } from "pages/students/nsc-colleges/NscCollegePage/NscCollegePage";
import { objectiveReportPageRoute } from "pages/reports/ObjectiveReportPage/ObjectiveReportPage";
import { aprTrioPageRoute } from "pages/ed-reports/AprTrio/AprTrioPage";
import { studentBulkMergePageRoute } from "pages/students/students/StudentBulkMergePage/StudentBulkMergePage";
import { aprEtsPageRoute } from "pages/ed-reports/AprEts/AprEtsPage";
import { staffListPageRoute } from "pages/staff/staff/StaffListPage/StaffListPage";
import { staffServiceListPageRoute } from "pages/staff/staff-services/StaffServiceListPage/StaffServiceListPage";
import { staffServicePageRoute } from "pages/staff/staff-services/StaffServicePage/StaffServicePage";
import { staffServiceBulkUpdatePageRoute } from "pages/staff/staff-services/StaffServiceBulkUpdatePage/StaffServiceBulkUpdatePage";
import { staffPageRoute } from "pages/staff/staff/StaffPage/StaffPage";
import { staffEmploymentPageRoute } from "pages/staff/staff-employments/StaffEmploymentPage/StaffEmploymentPage";
import { staffCreatePageRoute } from "pages/staff/staff/StaffCreatePage/StaffCreatePage";
import { staffBulkCreateServicesPageRoute } from "pages/staff/staff/StaffBulkCreateServicesPage/StaffBulkCreateServicesPage";
import {
  DeletedStudentListPage,
  deletedStudentsListPageRoute,
} from "pages/system/utility/deletedStudents/DeletedStudentListPage/DeletedStudentListPage";
import { staffReportPageRoute } from "pages/reports/StaffReportPage/StaffReportPage";
import { textingConversationsPageRoute } from "pages/texting/TextingConversationsPage/TextingConversationsPage";
import { createTextingConversationsPageRoute } from "pages/texting/CreateTextingConversationsPage/CreateTextingConversationsPage";
import { feederSchoolListPageRoute } from "pages/system/utility/feederSchools/FeederSchoolListPage/FeederSchoolListPage";
import { feederSchoolPageRoute } from "pages/system/utility/feederSchools/FeederSchoolPage/FeederSchoolPage";
import { fileCategoryListPageRoute } from "pages/system/utility/fileCategories/FileCategoryListPage/FileCategoryListPage";
import { fileCategoryPageRoute } from "pages/system/utility/fileCategories/FileCategoryPage/FileCategoryPage";
import { StudentFileListPage, studentFileListPageRoute } from "pages/students/student-files/StudentFileListPage/StudentFileListPage";
import { ClassCreatePage, classCreatePageRoute } from "pages/students/student-grades/StudentGradePage/ClassCreatePage/ClassCreatePage";
import { PersonTextingOptinPage, personTextingOptinPageRoute } from "pages/students/student-texting-optin/PersonTextingOptinPage";
import { AprUbPage, aprUbPageRoute } from "pages/ed-reports/AprUb/AprUbPage";
import { topicListPageRoute } from "pages/system/utility/topics/TopicListPage/TopicListPage";
import { topicPageRoute } from "pages/system/utility/topics/TopicPage/TopicPage";
import { TestTypeListPage, testTypeListPageRoute } from "pages/system/utility/TestTypes/TestTypesListPage/TestTypeListPage";
import { TestTypePage, testTypePageRoute } from "pages/system/utility/TestTypes/TestTypesPage/TestTypePage";
import { aprEocPageRoute } from "pages/ed-reports/AprEoc/AprEocPage";
import { surveyReportListPageRoute } from "pages/cobro/survey-reports/SurveyReportListPage/SurveyReportListPage";
import { surveyReportPageRoute } from "pages/cobro/survey-reports/SurveyReports/SurveyReportPage";
import { surveyReportReportPageRoute } from "pages/reports/SurveyReportReportPage/SurveyReportReportPage";
import { loginPageV2Route } from "pages/authV2/LoginPageV2";
import { forgotCredentialPageV2Route } from "pages/authV2/ForgotCredentialPageV2";
import { userRegisterPageV2Route } from "pages/authV2/UserRegisterPageV2";
import { fileDetailPageRoute } from "pages/students/student-applications/StudentApplicationPage/FileDetailPage/FileDetailPage";
import { AuthCallbackPage, AuthCallbackPageRoute } from "pages/auth/LoginPage/AuthCallbackPage";
import { tenantListPageRoute } from "pages/authV2/TenantListPage";
import { resetPasswordV2PageRoute } from "pages/auth/ResetPasswordPage/ResetPasswordPageV2";
import { TextingOptInPage, textingOptInPageRoute } from "pages/students/students/StudentTextingOptInPage/TextingOptInPage";

// Lazy Loading Component Pages.
// Avoiding importing all components / import component as we need
// By declaring each component as lazy promise so that it gets imported on the spot
// only when that component is being routed to
const {
  CreateTextingConversationsPage,
  StaffBulkCreateServicesPage,
  StaffCreatePage,
  StaffEmploymentPage,
  StaffServiceBulkUpdatePage,
  StaffListPage,
  StaffPage,
  StaffServiceListPage,
  StaffServicePage,
  NscCollegePage,
  AprPage,
  AprTrioPage,
  AprEtsPage,
  AprEocPage,
  ApplicationListPage,
  ApplicationPage,
  ClassListPage,
  ClassPage,
  CohortListPage,
  CohortPage,
  CollegeListPage,
  CollegePage,
  ContributorBulkCreateMatchesPage,
  ContributorBulkMergePage,
  ContributorCreatePage,
  ContributorEmploymentPage,
  ContributorListPage,
  ContributorMatchBulkUpdatePage,
  ContributorMatchListPage,
  ContributorMatchPage,
  ContributorMatchServiceListPage,
  ContributorMatchServicePage,
  ContributorPage,
  CustomDataModelFieldListPage,
  CustomDataModelFieldPage,
  DashboardReportPage,
  DataCenterFileCreatePage,
  DataCenterFileListPage,
  DataCenterFileViewPage,
  DeveloperBulkUpdatePage,
  DeveloperListPage,
  DeveloperPage,
  DiplomaTypeListPage,
  DiplomaTypePage,
  DistrictListPage,
  DistrictPage,
  DisciplinePage,
  DisciplineListPage,
  FeederSchoolListPage,
  FeederSchoolPage,
  FileCategoryPage,
  FileDetailPage,
  FileCategoryListPage,
  IEPListPage,
  IEPPage,
  PostHSPlanStatusListPage,
  PostHSPlanStatusPage,
  LEPListPage,
  LEPPage,
  EndReasonListPage,
  EndReasonPage,
  GradeListPage,
  GradePage,
  ExportPage,
  ObjectiveReportPage,
  ForgotCredentialPage,
  ForgotCredentialPageV2,
  HomelessDefinitionPage,
  HomePage,
  LoginPage,
  LoginPageV2,
  MatchReportPage,
  NonPersonnelListPage,
  NonPersonnelPage,
  PartnerCreatePage,
  PartnerIndirectCostPage,
  PartnerListPage,
  PartnerPage,
  ProviderCreatePage,
  ProviderEmploymentPage,
  ProviderListPage,
  ProviderPage,
  ProviderPositionListPage,
  ProviderPositionPage,
  PublicApplicationPage,
  PublicSurveyPage,
  RegionListPage,
  RegionPage,
  ResetPasswordPage,
  ResetPasswordV2Page,
  ScholarshipStatusListPage,
  ScholarshipStatusPage,
  ScholarshipPaymentMethodListPage,
  ScholarshipPaymentMethodPage,
  ScholarshipTypeListPage,
  ScholarshipTypePage,
  SchoolListPage,
  SchoolPage,
  StudentAbsencePage,
  StudentApplicationPage,
  StudentApplicationListPage,
  StudentBulkAssignGroupPage,
  StudentBulkCreateServicesPage,
  StudentBulkUpdatePage,
  StudentEmailPage,
  StudentBulkEmailPage,
  StudentBulkMergePage,
  StudentCreatePage,
  StudentDiplomaPage,
  StudentPostHighSchoolPage,
  StudentEnrollmentBulkUpdatePage,
  StudentEnrollmentListPage,
  StudentEnrollmentPage,
  StudentFafsaPage,
  StudentGpaPage,
  StudentGradeBulkCreatePage,
  StudentGradePage,
  StudentGroupBulkUpdatePage,
  StudentGroupListPage,
  StudentGroupPage,
  StudentLinkPage,
  StudentListPage,
  StudentPage,
  StudentParentPage,
  StudentParentTextingOptInPage,
  StudentReportPage,
  StudentScholarshipPage,
  StudentServiceBulkUpdatePage,
  StudentServiceListPage,
  StudentServicePage,
  StudentServiceIndexPage,
  StudentServiceIndexListPage,
  StudentServiceTemplateListPage,
  StudentServiceTemplatePage,
  StudentServiceTemplateSignUpPage,
  StudentServiceTypeListPage,
  StudentServiceTypePage,
  StaffPositionListPage,
  StaffPositionPage,
  StaffServiceTypeListPage,
  StaffServiceTypePage,
  StudentTestPage,
  SurveyReportPage,
  SurveyReportReportPage,
  SubPartnerPage,
  SuppliesDetailListPage,
  SuppliesDetailPage,
  SurveyExportPage,
  CobroSurveyExportPage,
  SurveyListPage,
  SurveyReportListPage,
  SurveyPage,
  SurveyResponseListPage,
  TestPage,
  TenantListPage,
  ThankYouPage,
  TopicListPage,
  TopicPage,
  The404Page,
  UserListPage,
  UserManualPage,
  UserPage,
  UserRegisterPage,
  UserRegisterPageV2,
  UtilityPage,
  StaffReportPage,
  TextingConversationsPage,
} = pagesLoader();
const authRoutes: RouteObject[] = [
  {
    path: loginPageRoute.templatePath,
    handle: loginPageRoute.handle,
    element: <LoginPage />,
  },
  {
    path: loginPageV2Route.templatePath,
    handle: loginPageV2Route.handle,
    element: <LoginPageV2 />,
  },
  {
    path: tenantListPageRoute.templatePath,
    handle: tenantListPageRoute.handle,
    element: <TenantListPage />,
  },
  {
    path: AuthCallbackPageRoute.templatePath,
    handle: AuthCallbackPageRoute.handle,
    element: <AuthCallbackPage />,
  },
  {
    path: forgotCredentialPageRoute.templatePath,
    handle: forgotCredentialPageRoute.handle,
    element: <ForgotCredentialPage />,
  },
  {
    path: forgotCredentialPageV2Route.templatePath,
    handle: forgotCredentialPageV2Route.handle,
    element: <ForgotCredentialPageV2 />,
  },
  {
    path: resetPasswordPageRoute.templatePath,
    handle: resetPasswordPageRoute.handle,
    element: <ResetPasswordPage />,
  },
  {
    path: resetPasswordV2PageRoute.templatePath,
    handle: resetPasswordV2PageRoute.handle,
    element: <ResetPasswordV2Page />,
  },
  {
    path: userRegisterPageRoute.templatePath,
    handle: userRegisterPageRoute.handle,
    element: <UserRegisterPage />,
  },
  {
    path: userRegisterPageV2Route.templatePath,
    handle: userRegisterPageV2Route.handle,
    element: <UserRegisterPageV2 />,
  },
];

const publicRoutes: RouteObject[] = [
  {
    path: publicSurveyPageRoute.templatePath,
    handle: publicSurveyPageRoute.handle,
    element: <PublicSurveyPage />,
  },
  {
    path: publicApplicationPageRoute.templatePath,
    handle: publicApplicationPageRoute.handle,
    element: <PublicApplicationPage />,
    children: [
      {
        path: homelessDefinitionPageRoute.templatePath,
        handle: homelessDefinitionPageRoute.handle,
        element: <HomelessDefinitionPage />,
      },
    ],
  },
  {
    path: studentServiceTemplateSignUpPageRoute.templatePath,
    handle: studentServiceTemplateSignUpPageRoute.handle,
    element: <StudentServiceTemplateSignUpPage />,
  },
];

const navRoutes: RouteObject[] = [
  { element: <Navigate to={homePageRoute.templatePath} replace />, index: true }, // default
  {
    element: <TestPage />,
    path: testPageRoute.templatePath,
    handle: testPageRoute.handle,
  },
  {
    path: homePageRoute.templatePath,
    handle: homePageRoute.handle,
    element: <HomePage />,
  },
  {
    path: aprPageRoute.templatePath,
    handle: aprPageRoute.handle,
    element: <AprPage />,
  },
  {
    path: aprTrioPageRoute.templatePath,
    handle: aprTrioPageRoute.handle,
    element: <AprTrioPage />,
  },
  {
    path: aprEtsPageRoute.templatePath,
    handle: aprEtsPageRoute.handle,
    element: <AprEtsPage />,
  },
  {
    path: aprEocPageRoute.templatePath,
    handle: aprEocPageRoute.handle,
    element: <AprEocPage />,
  },
  {
    path: aprUbPageRoute.templatePath,
    handle: aprUbPageRoute.handle,
    element: <AprUbPage />,
  },
  {
    path: developerListPageRoute.templatePath,
    handle: developerListPageRoute.handle,
    element: <DeveloperListPage />,
    children: [
      {
        path: developerPageRoute.templatePath,
        handle: developerPageRoute.handle,
        element: <DeveloperPage />,
      },
      {
        path: developerBulkUpdatePageRoute.templatePath,
        handle: developerBulkUpdatePageRoute.handle,
        element: <DeveloperBulkUpdatePage />,
      },
    ],
  },
  {
    path: cobroSurveyExportPageRoute.templatePath,
    handle: cobroSurveyExportPageRoute.handle,
    element: <CobroSurveyExportPage />,
    children: [],
  },
  {
    path: surveyExportPageRoute.templatePath,
    handle: surveyExportPageRoute.handle,
    element: <SurveyExportPage />,
    children: [],
  },
  {
    path: surveyResponseListPageRoute.templatePath,
    handle: surveyResponseListPageRoute.handle,
    element: <SurveyResponseListPage />,
    children: [
      {
        path: surveyResponseStudentPageRoute.templatePath,
        handle: surveyResponseStudentPageRoute.handle,
        element: <SurveyResponseStudentPage />,
      },
    ],
  },
  {
    path: textingConversationsPageRoute.templatePath,
    handle: textingConversationsPageRoute.handle,
    element: <TextingConversationsPage />,
    children: [
      {
        path: createTextingConversationsPageRoute.templatePath,
        handle: createTextingConversationsPageRoute.handle,
        element: <CreateTextingConversationsPage />,
      },
    ]
    // children: [
    //   {
    //     path: ":personType",
    //     handle: textingConversationListPageRoute.handle,
    //     element: <TextingConversationContent />,
    //     children: [
    //       {
    //         path: ":textingConversationId",
    //         handle: textingConversationListPageRoute.handle,
    //         element: <TextingConversationContentDetail />,
    //       },
    //     ],
    //   },
    // ],
  },
  {
    path: applicationListPageRoute.templatePath,
    handle: applicationListPageRoute.handle,
    element: <ApplicationListPage />,
    children: [
      {
        path: applicationPageRoute.templatePath,
        handle: applicationPageRoute.handle,
        element: <ApplicationPage />,
      },
    ],
  },
  {
    path: surveyListPageRoute.templatePath,
    handle: surveyListPageRoute.handle,
    element: <SurveyListPage />,
    children: [
      {
        path: surveyPageRoute.templatePath,
        handle: surveyPageRoute.handle,
        element: <SurveyPage />,
      },
    ],
  },
  {
    path: surveyReportListPageRoute.templatePath,
    handle: surveyReportListPageRoute.handle,
    element: <SurveyReportListPage />,
    children: [
      {
        path: surveyReportPageRoute.templatePath,
        handle: surveyReportPageRoute.handle,
        element: <SurveyReportPage />,
      },
    ],
  },
  {
    path: userManualPageRoute.templatePath,
    handle: userManualPageRoute.handle,
    element: <UserManualPage />,
    children: [
      {
        path: ":uniqueIdentifier",
        handle: userManualPageRoute.handle,
        element: <UserManualContent />,
      },
    ],
  },
  {
    path: contributorListPageRoute.templatePath,
    handle: contributorListPageRoute.handle,
    element: <ContributorListPage />,
    children: [
      {
        path: contributorCreatePageRoute.templatePath,
        handle: contributorCreatePageRoute.handle,
        element: <ContributorCreatePage />,
      },
      {
        path: contributorMatchPageRoute.templatePath,
        handle: contributorMatchPageRoute.handle,
        element: <ContributorMatchPage />,
      },
      {
        path: contributorPageRoute.templatePath,
        handle: contributorPageRoute.handle,
        element: <ContributorPage />,
        children: [
          {
            path: contributorMatchPageRoute.templatePath,
            handle: contributorMatchPageRoute.handle,
            element: <ContributorMatchPage />,
          },
          {
            path: contributorEmploymentPageRoute.templatePath,
            handle: contributorEmploymentPageRoute.handle,
            element: <ContributorEmploymentPage />,
          },
        ],
      },
      {
        path: contributorBulkCreateMatchesPageRoute.templatePath,
        handle: contributorBulkCreateMatchesPageRoute.handle,
        element: <ContributorBulkCreateMatchesPage />,
      },
      {
        path: contributorBulkMergePageRoute.templatePath,
        handle: contributorBulkMergePageRoute.handle,
        element: <ContributorBulkMergePage />,
      },
    ],
  },
  {
    path: contributorMatchListPageRoute.templatePath,
    handle: contributorMatchListPageRoute.handle,
    element: <ContributorMatchListPage />,
    children: [
      {
        path: contributorMatchPageRoute.templatePath,
        handle: contributorMatchPageRoute.handle,
        element: <ContributorMatchPage />,
      },
      {
        path: contributorMatchBulkUpdatePageRoute.templatePath,
        handle: contributorMatchBulkUpdatePageRoute.handle,
        element: <ContributorMatchBulkUpdatePage />,
      },
    ],
  },
  {
    path: providerListPageRoute.templatePath,
    handle: providerListPageRoute.handle,
    element: <ProviderListPage />,
    children: [
      {
        path: providerCreatePageRoute.templatePath,
        handle: providerCreatePageRoute.handle,
        element: <ProviderCreatePage />,
      },
      {
        path: providerPageRoute.templatePath,
        handle: providerPageRoute.handle,
        element: <ProviderPage />,
        children: [
          {
            path: providerEmploymentPageRoute.templatePath,
            handle: providerEmploymentPageRoute.handle,
            element: <ProviderEmploymentPage />,
          },
        ],
      },
    ],
  },
  {
    path: userListPageRoute.templatePath,
    handle: userListPageRoute.handle,
    element: <UserListPage />,
    children: [
      {
        path: userPageRoute.templatePath,
        handle: userPageRoute.handle,
        element: <UserPage />
      }
    ],
  },
  {
    path: userPageRoute.templatePath,
    handle: userPageRoute.handle,
    element: <UserPage />
  },
  {
    path: contributorMatchServiceListPageRoute.templatePath,
    handle: contributorMatchServiceListPageRoute.handle,
    element: <ContributorMatchServiceListPage />,
    children: [
      {
        path: contributorMatchServicePageRoute.templatePath,
        handle: contributorMatchServicePageRoute.handle,
        element: <ContributorMatchServicePage />,
      },
    ],
  },
  {
    path: suppliesDetailListPageRoute.templatePath,
    handle: suppliesDetailListPageRoute.handle,
    element: <SuppliesDetailListPage />,
    children: [
      {
        path: suppliesDetailPageRoute.templatePath,
        handle: suppliesDetailPageRoute.handle,
        element: <SuppliesDetailPage />,
      },
    ],
  },
  {
    path: partnerListPageRoute.templatePath,
    handle: partnerListPageRoute.handle,
    element: <PartnerListPage />,
    children: [
      {
        path: partnerCreatePageRoute.templatePath,
        handle: partnerCreatePageRoute.handle,
        element: <PartnerCreatePage />,
      },
      {
        path: partnerPageRoute.templatePath,
        handle: partnerPageRoute.handle,
        element: <PartnerPage />,
        children: [
          {
            path: partnerIndirectCostPageRoute.templatePath,
            handle: partnerIndirectCostPageRoute.handle,
            element: <PartnerIndirectCostPage />,
          },
          {
            path: subPartnerPageRoute.templatePath,
            handle: subPartnerPageRoute.handle,
            element: <SubPartnerPage />,
          },
        ],
      },
    ],
  },
  {
    path: matchReportPageRoute.templatePath,
    handle: matchReportPageRoute.handle,
    element: <MatchReportPage />,
    children: [
      { path: matchReportPageRoute.templatePath, handle: matchReportPageRoute.handle, element: <MatchReportPage /> },
    ],
  },
  {
    path: nonPersonnelListPageRoute.templatePath,
    handle: nonPersonnelListPageRoute.handle,
    element: <NonPersonnelListPage />,
    children: [
      {
        path: nonPersonnelPageRoute.templatePath,
        handle: nonPersonnelPageRoute.handle,
        element: <NonPersonnelPage />,
      },
    ],
  },
  {
    path: dataCenterFileListPageRoute.templatePath,
    handle: dataCenterFileListPageRoute.handle,
    element: <DataCenterFileListPage />,
    children: [
      {
        path: dataCenterFileViewPageRoute.templatePath,
        handle: dataCenterFileViewPageRoute.handle,
        element: <DataCenterFileViewPage />,
      },
      {
        path: dataCenterFileCreatePageRoute.templatePath,
        handle: dataCenterFileCreatePageRoute.handle,
        element: <DataCenterFileCreatePage />,
      },
    ],
  },
  {
    path: staffListPageRoute.templatePath,
    handle: staffListPageRoute.handle,
    element: <StaffListPage />,
    children: [
      {
        path: staffBulkCreateServicesPageRoute.templatePath,
        handle: staffBulkCreateServicesPageRoute.handle,
        element: <StaffBulkCreateServicesPage />,
      },
      {
        path: staffCreatePageRoute.templatePath,
        handle: staffCreatePageRoute.handle,
        element: <StaffCreatePage />,
      },
      {
        path: staffPageRoute.templatePath,
        handle: staffPageRoute.handle,
        element: <StaffPage />,
        children: [
          {
            path: staffServicePageRoute.templatePath,
            handle: staffServicePageRoute.handle,
            element: <StaffServicePage />,
          },
          {
            path: staffEmploymentPageRoute.templatePath,
            handle: staffEmploymentPageRoute.handle,
            element: <StaffEmploymentPage />,
          },
        ],
      },
      {
        path: staffServicePageRoute.templatePath,
        handle: staffServicePageRoute.handle,
        element: <StaffServicePage />,
      },
    ],
  },
  {
    path: staffServiceListPageRoute.templatePath,
    handle: staffServiceListPageRoute.handle,
    element: <StaffServiceListPage />,
    children: [
      {
        path: staffServicePageRoute.templatePath,
        handle: staffServicePageRoute.handle,
        element: <StaffServicePage />,
      },
      {
        path: staffServiceBulkUpdatePageRoute.templatePath,
        handle: staffServiceBulkUpdatePageRoute.handle,
        element: <StaffServiceBulkUpdatePage />,
      },
    ],
  },
  {
    path: studentListPageRoute.templatePath,
    handle: studentListPageRoute.handle,
    element: <StudentListPage />,
    children: [
      {
        path: studentCreatePageRoute.templatePath,
        handle: studentCreatePageRoute.handle,
        element: <StudentCreatePage />,
      },
      {
        path: studentBulkMergePageRoute.templatePath,
        handle: studentBulkMergePageRoute.handle,
        element: <StudentBulkMergePage />,
      },
      {
        path: studentPageRoute.templatePath,
        handle: studentPageRoute.handle,
        element: <StudentPage />,
        children: [
          {
            path: fileDetailPageRoute.templatePath,
            handle: fileDetailPageRoute.handle,
            element: <FileDetailPage />,
          },
          {
            path: studentQrPageRoute.templatePath,
            handle: studentQrPageRoute.handle,
            element: <StudentQrPage />,
          },
          {
            path: studentEmailPageRoute.templatePath,
            handle: studentEmailPageRoute.handle,
            element: <StudentEmailPage />,
          },
          {
            path: textingOptInPageRoute.templatePath,
            handle: textingOptInPageRoute.handle,
            element: <TextingOptInPage />,
            children: [
              {
                path: personTextingOptinPageRoute.templatePath,
                handle: personTextingOptinPageRoute.handle,
                element: <PersonTextingOptinPage />,
              },
            ]
          },
          {
            path: studentEnrollmentPageRoute.templatePath,
            handle: studentEnrollmentPageRoute.handle,
            element: <StudentEnrollmentPage />,
          },
          {
            path: studentServicePageRoute.templatePath,
            handle: studentServicePageRoute.handle,
            element: <StudentServicePage />,
            children: [
              {
                path: providerCreatePageRoute.templatePath,
                handle: providerCreatePageRoute.handle,
                element: <ProviderCreatePage />,
              },
              {
                path: fileDetailPageRoute.templatePath,
                handle: fileDetailPageRoute.handle,
                element: <FileDetailPage />,
              },
              {
                path: collegePageRoute.templatePath,
                handle: collegePageRoute.handle,
                element: <CollegePage />,
              },
              {
                path: studentServiceIndexListPageRoute.templatePath,
                handle: studentServiceIndexListPageRoute.handle,
                element: <StudentServiceIndexListPage />,
              },
            ],
          },
          {
            path: studentGradePageRoute.templatePath,
            handle: studentGradePageRoute.handle,
            element: <StudentGradePage />,
            children: [
              {
                path: classCreatePageRoute.templatePath,
                handle: classCreatePageRoute.handle,
                element: <ClassCreatePage />,
              },
            ]
          },
          {
            path: studentGradeBulkCreatePageRoute.templatePath,
            handle: studentGradeBulkCreatePageRoute.handle,
            element: <StudentGradeBulkCreatePage />,
            children: [
              {
                path: classCreatePageRoute.templatePath,
                handle: classCreatePageRoute.handle,
                element: <ClassCreatePage />,
              },
            ]
          },
          {
            path: studentGpaPageRoute.templatePath,
            handle: studentGpaPageRoute.handle,
            element: <StudentGpaPage />,
          },
          {
            path: studentAbsencePageRoute.templatePath,
            handle: studentAbsencePageRoute.handle,
            element: <StudentAbsencePage />,
          },
          {
            path: studentTestPageRoute.templatePath,
            handle: studentTestPageRoute.handle,
            element: <StudentTestPage />,
          },
          {
            path: studentDiplomaPageRoute.templatePath,
            handle: studentDiplomaPageRoute.handle,
            element: <StudentDiplomaPage />,
          },
          {
            path: studentPostHighSchoolPageRoute.templatePath,
            handle: studentPostHighSchoolPageRoute.handle,
            element: <StudentPostHighSchoolPage />,
            children: [
              {
                path: collegePageRoute.templatePath,
                handle: collegePageRoute.handle,
                element: <CollegePage />,
              },
            ],
          },
          {
            path: studentScholarshipPageRoute.templatePath,
            handle: studentScholarshipPageRoute.handle,
            element: <StudentScholarshipPage />,
          },
          {
            path: studentFafsaPageRoute.templatePath,
            handle: studentFafsaPageRoute.handle,
            element: <StudentFafsaPage />,
          },
          {
            path: studentParentPageRoute.templatePath,
            handle: studentParentPageRoute.handle,
            element: <StudentParentPage />,
            children: [
              {
                path: parentTextingOptInPageRoute.templatePath,
                handle: parentTextingOptInPageRoute.handle,
                element: <StudentParentTextingOptInPage />,
                children: [
                  {
                    path: personTextingOptinPageRoute.templatePath,
                    handle: personTextingOptinPageRoute.handle,
                    element: <PersonTextingOptinPage />,
                  },
                ],
              },
            ],
          },
          {
            path: nscCollegePageRoute.templatePath,
            handle: nscCollegePageRoute.handle,
            element: <NscCollegePage />,
          },
        ],
      },
      {
        path: fileDetailPageRoute.templatePath,
        handle: fileDetailPageRoute.handle,
        element: <FileDetailPage />,
      },
      {
        path: studentServicePageRoute.templatePath,
        handle: studentServicePageRoute.handle,
        element: <StudentServicePage />,
        children: [
          {
            path: studentServiceIndexListPageRoute.templatePath,
            handle: studentServiceIndexListPageRoute.handle,
            element: <StudentServiceIndexListPage />,
          },
          {
            path: fileDetailPageRoute.templatePath,
            handle: fileDetailPageRoute.handle,
            element: <FileDetailPage />,
          },
          {
            path: collegePageRoute.templatePath,
            handle: collegePageRoute.handle,
            element: <CollegePage />,
          },
          {
            path: providerCreatePageRoute.templatePath,
            handle: providerCreatePageRoute.handle,
            element: <ProviderCreatePage />,
          },
        ],
      },

      {
        path: studentBulkUpdatePageRoute.templatePath,
        handle: studentBulkUpdatePageRoute.handle,
        element: <StudentBulkUpdatePage />,
      },
      {
        path: studentBulkAssignGroupPageRoute.templatePath,
        handle: studentBulkAssignGroupPageRoute.handle,
        element: <StudentBulkAssignGroupPage />,
      },
      {
        path: studentBulkEmailPageRoute.templatePath,
        handle: studentBulkEmailPageRoute.handle,
        element: <StudentBulkEmailPage />,
      },
      {
        path: studentBulkCreateServicesPageRoute.templatePath,
        handle: studentBulkCreateServicesPageRoute.handle,
        element: <StudentBulkCreateServicesPage />,
        children: [
          {
            path: providerCreatePageRoute.templatePath,
            handle: providerCreatePageRoute.handle,
            element: <ProviderCreatePage />,
          },
          {
            path: collegePageRoute.templatePath,
            handle: collegePageRoute.handle,
            element: <CollegePage />,
          },
          {
            path: studentServiceIndexListPageRoute.templatePath,
            handle: studentServiceIndexListPageRoute.handle,
            element: <StudentServiceIndexListPage />,
          },
        ],
      },
      {
        path: createTextingConversationsPageRoute.templatePath,
        handle: createTextingConversationsPageRoute.handle,
        element: <CreateTextingConversationsPage />,
      },
    ],
  },
  {
    path: customDataModelFieldListPageRoute.templatePath,
    handle: customDataModelFieldListPageRoute.handle,
    element: <CustomDataModelFieldListPage />,
    children: [
      {
        path: customDataModelFieldPageRoute.templatePath,
        handle: customDataModelFieldPageRoute.handle,
        element: <CustomDataModelFieldPage />,
      },
    ],
  },
  {
    path: studentServiceListPageRoute.templatePath,
    handle: studentServiceListPageRoute.handle,
    element: <StudentServiceListPage />,
    children: [
      {
        path: studentServicePageRoute.templatePath,
        handle: studentServicePageRoute.handle,
        element: <StudentServicePage />,
        children: [
          {
            path: studentServiceIndexListPageRoute.templatePath,
            handle: studentServiceIndexListPageRoute.handle,
            element: <StudentServiceIndexListPage />,
          },
          {
            path: fileDetailPageRoute.templatePath,
            handle: fileDetailPageRoute.handle,
            element: <FileDetailPage />,
          },
          {
            path: providerCreatePageRoute.templatePath,
            handle: providerCreatePageRoute.handle,
            element: <ProviderCreatePage />,
          },
          {
            path: collegePageRoute.templatePath,
            handle: collegePageRoute.handle,
            element: <CollegePage />,
          },
        ],
      },
      {
        path: studentServiceBulkUpdatePageRoute.templatePath,
        handle: studentServiceBulkUpdatePageRoute.handle,
        element: <StudentServiceBulkUpdatePage />,
        children: [
          {
            path: providerCreatePageRoute.templatePath,
            handle: providerCreatePageRoute.handle,
            element: <ProviderCreatePage />,
          },
        ],
      },
    ],
  },
  {
    path: studentEnrollmentListPageRoute.templatePath,
    handle: studentEnrollmentListPageRoute.handle,
    element: <StudentEnrollmentListPage />,
    children: [
      {
        path: studentEnrollmentPageRoute.templatePath,
        handle: studentEnrollmentPageRoute.handle,
        element: <StudentEnrollmentPage />,
      },
      {
        path: studentEnrollmentBulkUpdatePageRoute.templatePath,
        handle: studentEnrollmentBulkUpdatePageRoute.handle,
        element: <StudentEnrollmentBulkUpdatePage />,
      },
    ],
  },
  {
    path: studentGroupListPageRoute.templatePath,
    handle: studentGroupListPageRoute.handle,
    element: <StudentGroupListPage />,
    children: [
      {
        path: studentGroupPageRoute.templatePath,
        handle: studentGroupPageRoute.handle,
        element: <StudentGroupPage />,
      },
      {
        path: studentGroupBulkUpdatePageRoute.templatePath,
        handle: studentGroupBulkUpdatePageRoute.handle,
        element: <StudentGroupBulkUpdatePage />,
      },
    ],
  },
  {
    path: studentApplicationListPageRoute.templatePath,
    handle: studentApplicationListPageRoute.handle,
    element: <StudentApplicationListPage />,
    children: [
      {
        path: studentApplicationPageRoute.templatePath,
        handle: studentApplicationPageRoute.handle,
        element: <StudentApplicationPage />,
        children: [
          {
            path: fileDetailPageRoute.templatePath,
            handle: fileDetailPageRoute.handle,
            element: <FileDetailPage />,
          },
        ],
      },
    ],
  },
  {
    path: studentFileListPageRoute.templatePath,
    handle: studentFileListPageRoute.handle,
    element: <StudentFileListPage />,
    children: [
    ],
  },
  {
    path: studentServiceTemplateListPageRoute.templatePath,
    handle: studentServiceTemplateListPageRoute.handle,
    element: <StudentServiceTemplateListPage />,
    children: [
      {
        path: studentServiceTemplatePageRoute.templatePath,
        handle: studentServiceTemplatePageRoute.handle,
        element: <StudentServiceTemplatePage />,
        children: [
          {
            path: studentLinkPageRoute.templatePath,
            handle: studentLinkPageRoute.handle,
            element: <StudentLinkPage />,
          },
        ],
      },
    ],
  },
  {
    path: exportPageRoute.templatePath,
    handle: exportPageRoute.handle,
    element: <ExportPage />,
  },
  {
    path: surveyReportReportPageRoute.templatePath,
    handle: surveyReportReportPageRoute.handle,
    element: <SurveyReportReportPage />,
  },
  {
    path: objectiveReportPageRoute.templatePath,
    handle: objectiveReportPageRoute.handle,
    element: <ObjectiveReportPage />,
  },
  {
    path: studentReportPageRoute.templatePath,
    handle: studentReportPageRoute.handle,
    element: <StudentReportPage />,
  },
  {
    path: staffReportPageRoute.templatePath,
    handle: staffReportPageRoute.handle,
    element: <StaffReportPage />,
  },
  {
    path: dashboardReportPageRoute.templatePath,
    handle: dashboardReportPageRoute.handle,
    element: <DashboardReportPage />,
  },
  {// gg: routes moved outside of utilityLayoutRoutePath
    path: ClassListPageRoute.templatePath,
    handle: ClassListPageRoute.handle,
    element: <ClassListPage />,
    children: [
      {
        path: ClassPageRoute.templatePath,
        handle: ClassPageRoute.handle,
        element: <ClassPage />,
      },
    ],
  },
  {
    path: collegeListPageRoute.templatePath,
    handle: collegeListPageRoute.handle,
    element: <CollegeListPage />,
    children: [
      {
        path: collegePageRoute.templatePath,
        handle: collegePageRoute.handle,
        element: <CollegePage />,
      },
    ],
  }, {
    path: cohortListPageRoute.templatePath,
    handle: cohortListPageRoute.handle,
    element: <CohortListPage />,
    children: [
      {
        path: cohortPageRoute.templatePath,
        handle: cohortPageRoute.handle,
        element: <CohortPage />,
      },
    ],
  },
  {
    path: gradeListPageRoute.templatePath,
    handle: gradeListPageRoute.handle,
    element: <GradeListPage />,
    children: [
      {
        path: gradePageRoute.templatePath,
        handle: gradePageRoute.handle,
        element: <GradePage />,
      },
    ],
  }, {
    path: deletedStudentsListPageRoute.templatePath,
    handle: deletedStudentsListPageRoute.handle,
    element: <DeletedStudentListPage />,
    children: [
      {
        path: collegePageRoute.templatePath,
        handle: collegePageRoute.handle,
        element: <CollegePage />,
      },
    ],
  }, {
    path: districtListPageRoute.templatePath,
    handle: districtListPageRoute.handle,
    element: <DistrictListPage />,
    children: [
      {
        path: districtPageRoute.templatePath,
        handle: districtPageRoute.handle,
        element: <DistrictPage />,
      },
    ],
  }, {
    path: diplomaTypeListPageRoute.templatePath,
    handle: diplomaTypeListPageRoute.handle,
    element: <DiplomaTypeListPage />,
    children: [
      {
        path: diplomaTypePageRoute.templatePath,
        handle: diplomaTypePageRoute.handle,
        element: <DiplomaTypePage />,
      },
    ],
  },
  {
    path: testTypeListPageRoute.templatePath,
    handle: testTypeListPageRoute.handle,
    element: <TestTypeListPage />,
    children: [
      {
        path: testTypePageRoute.templatePath,
        handle: testTypePageRoute.handle,
        element: <TestTypePage />,
      },
    ],
  },
  {
    path: topicListPageRoute.templatePath,
    handle: topicListPageRoute.handle,
    element: <TopicListPage />,
    children: [
      {
        path: topicPageRoute.templatePath,
        handle: topicPageRoute.handle,
        element: <TopicPage />,
      },
    ],
  },
  {
    path: disciplineListPageRoute.templatePath,
    handle: disciplineListPageRoute.handle,
    element: <DisciplineListPage />,
    children: [
      {
        path: disciplinePageRoute.templatePath,
        handle: disciplinePageRoute.handle,
        element: <DisciplinePage />,
      },
    ],
  }, {
    path: endReasonListPageRoute.templatePath,
    handle: endReasonListPageRoute.handle,
    element: <EndReasonListPage />,
    children: [
      {
        path: endReasonPageRoute.templatePath,
        handle: endReasonPageRoute.handle,
        element: <EndReasonPage />,
      },
    ],
  }, {
    path: feederSchoolListPageRoute.templatePath,
    handle: feederSchoolListPageRoute.handle,
    element: <FeederSchoolListPage />,
    children: [
      {
        path: feederSchoolPageRoute.templatePath,
        handle: feederSchoolPageRoute.handle,
        element: <FeederSchoolPage />,
      },
    ],
  }, {
    path: fileCategoryListPageRoute.templatePath,
    handle: fileCategoryListPageRoute.handle,
    element: <FileCategoryListPage />,
    children: [
      {
        path: fileCategoryPageRoute.templatePath,
        handle: fileCategoryPageRoute.handle,
        element: <FileCategoryPage />,
      },
    ],
  }, {
    path: iepListPageRoute.templatePath,
    handle: iepListPageRoute.handle,
    element: <IEPListPage />,
    children: [
      {
        path: iepPageRoute.templatePath,
        handle: iepPageRoute.handle,
        element: <IEPPage />,
      },
    ],
  },
  {
    path: lepListPageRoute.templatePath,
    handle: lepListPageRoute.handle,
    element: <LEPListPage />,
    children: [
      {
        path: lepPageRoute.templatePath,
        handle: lepPageRoute.handle,
        element: <LEPPage />,
      },
    ],
  },
  {
    path: postHSPlanStatusListPageRoute.templatePath,
    handle: postHSPlanStatusListPageRoute.handle,
    element: <PostHSPlanStatusListPage />,
    children: [
      {
        path: postHSPlanStatusPageRoute.templatePath,
        handle: postHSPlanStatusPageRoute.handle,
        element: <PostHSPlanStatusPage />,
      },
    ],
  },
  {
    path: providerListPageRoute.templatePath,
    handle: providerListPageRoute.handle,
    element: <ProviderListPage />,
    children: [
      {
        path: providerCreatePageRoute.templatePath,
        handle: providerCreatePageRoute.handle,
        element: <ProviderCreatePage />,
      },
      {
        path: providerPageRoute.templatePath,
        handle: providerPageRoute.handle,
        element: <ProviderPage />,
        children: [
          {
            path: providerEmploymentPageRoute.templatePath,
            handle: providerEmploymentPageRoute.handle,
            element: <ProviderEmploymentPage />,
          },
        ],
      },
    ],
  }, {
    path: providerPositionListPageRoute.templatePath,
    handle: providerPositionListPageRoute.handle,
    element: <ProviderPositionListPage />,
    children: [
      {
        path: providerPositionPageRoute.templatePath,
        handle: providerPositionPageRoute.handle,
        element: <ProviderPositionPage />,
      },
    ],
  }, {
    path: scholarshipPaymentMethodListPageRoute.templatePath,
    handle: scholarshipPaymentMethodListPageRoute.handle,
    element: <ScholarshipPaymentMethodListPage />,
    children: [
      {
        path: scholarshipPaymentMethodPageRoute.templatePath,
        handle: scholarshipPaymentMethodPageRoute.handle,
        element: <ScholarshipPaymentMethodPage />,
      },
    ],
  }, {
    path: scholarshipStatusListPageRoute.templatePath,
    handle: scholarshipStatusListPageRoute.handle,
    element: <ScholarshipStatusListPage />,
    children: [
      {
        path: scholarshipStatusPageRoute.templatePath,
        handle: scholarshipStatusPageRoute.handle,
        element: <ScholarshipStatusPage />,
      },
    ],
  }, {
  },
  {
    path: regionListPageRoute.templatePath,
    handle: regionListPageRoute.handle,
    element: <RegionListPage />,
    children: [
      {
        path: regionPageRoute.templatePath,
        handle: regionPageRoute.handle,
        element: <RegionPage />,
      },
    ],
  },
  {
    path: scholarshipTypeListPageRoute.templatePath,
    handle: scholarshipTypeListPageRoute.handle,
    element: <ScholarshipTypeListPage />,
    children: [
      {
        path: scholarshipTypePageRoute.templatePath,
        handle: scholarshipTypePageRoute.handle,
        element: <ScholarshipTypePage />,
      },
    ],
  },
  {
    path: schoolListPageRoute.templatePath,
    handle: schoolListPageRoute.handle,
    element: <SchoolListPage />,
    children: [
      {
        path: schoolPageRoute.templatePath,
        handle: schoolPageRoute.handle,
        element: <SchoolPage />,
      },
    ],
  }, {
    path: studentServiceIndexListPageRoute.templatePath,
    handle: studentServiceIndexListPageRoute.handle,
    element: <StudentServiceIndexListPage />,
    children: [
      {
        path: studentServiceIndexPageRoute.templatePath,
        handle: studentServiceIndexPageRoute.handle,
        element: <StudentServiceIndexPage />,
      },
    ],
  }, {
    path: studentServiceTypeListPageRoute.templatePath,
    handle: studentServiceTypeListPageRoute.handle,
    element: <StudentServiceTypeListPage />,
    children: [
      {
        path: studentServiceTypePageRoute.templatePath,
        handle: studentServiceTypePageRoute.handle,
        element: <StudentServiceTypePage />,
      },
    ],
  }, {
    path: staffPositionListPageRoute.templatePath,
    handle: staffPositionListPageRoute.handle,
    element: <StaffPositionListPage />,
    children: [
      {
        path: staffPositionPageRoute.templatePath,
        handle: staffPositionPageRoute.handle,
        element: <StaffPositionPage />,
      },
    ],
  },
  {
    path: staffServiceTypeListPageRoute.templatePath,
    handle: staffServiceTypeListPageRoute.handle,
    element: <StaffServiceTypeListPage />,
    children: [
      {
        path: staffServiceTypePageRoute.templatePath,
        handle: staffServiceTypePageRoute.handle,
        element: <StaffServiceTypePage />,
      },
    ],
  },
];
export const appRoutes: RouteObject[] = [
  // {
  //   path: "auth-callback",
  //   element: <SsoCallbackPage />
  // },
  {
    path: "",
    element: <Layout />,
    children: [
      {
        path: "",
        element: (
          <AuthGuard>
            <NavLayout />
          </AuthGuard>
        ),
        children: navRoutes,
      },
      {
        path: "",
        element: <AuthLayout />,
        children: authRoutes,
      },
      {
        path: "",
        element: <PublicLayout />,
        children: publicRoutes,
      },
      { path: the404PageRoute.templatePath, handle: the404PageRoute.handle, element: <The404Page /> },
      { path: thankYouPageRoute.templatePath, handle: thankYouPageRoute.handle, element: <ThankYouPage /> },
      // { path: "*", element: <Navigate to="/404" replace /> },];
    ],
  },
];

export const AppRoutes = () => {
  return useRoutes(appRoutes);
};
